import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { HomePage } from './home-page/home-page';
import { ChatPage } from './chat-page/chat-page';
import { AssetDetailPage } from './asset-detail-page/asset-detail-page';
import { GetStartedPage } from './get-started-page/get-started-page';
import { AssetCatalogPage } from './asset-catalog-page/asset-catalog-page';
import { FaqPage } from './faq-page/faq-page';
import { RedirectComponent } from './redirect/redirect.component';

export const routes: Routes = [
  // Unguarded routes
  {
    path: 'auth-callback',
    component: RedirectComponent,
  },
  // Guarded routes
  {
    path: '',
    canActivate: [MsalGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomePage },
      { path: 'get-started', component: GetStartedPage },
      { path: 'faq', component: FaqPage },
      { path: 'chat/:chatId', component: ChatPage },
      { path: 'assets/:assetId', component: AssetDetailPage },
      { path: 'catalog', component: AssetCatalogPage },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
